<template>
  <div>
    <div class="px-9 py-2">
      <div class="my-4">
        <h1>Related content</h1>
      </div>
      <v-row>
        <v-col cols="8" md="12" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              hide-details
              single-line
              v-model="search"
              @input="fetchData()"
            >
            </v-text-field>
          </v-card>
        </v-col>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="blogs"
        hide-default-header
        class="mt-4"
      >
        <template v-slot:[`item.images`]="{ item }">
          <v-card
            flat
            color="transparent"
            style="max-width: fit-content"
            class="pa-1"
          >
            <v-img
              contain
              :src="item.Banner"
              alt="John"
              height="50"
              width="80"
            />
          </v-card>
        </template>
        <template v-slot:[`item.title`]="{ item }">
          <div>
            <span class="table_style_one"> {{ item.Title }} </span>
          </div>
          <div class="my-1">
            <v-chip
              v-if="item.Visibility"
              label
              color="#£E5F5E6"
              small
              class="chips_style"
            >
              {{ item.Visibility ? "Published" : "" }}
            </v-chip>
            <span class="mx-3 date_time_style">{{
              item.ModifiedDate == null
                ? new Date().toISOString().split("T")[0]
                : item.ModifiedDate.split("T")[0]
            }}</span>
          </div>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-switch
            v-model="item.selected"
            @change="onChange(item, $event)"
            :disabled="
              GetSelectedRelatedBlogs.length >= 3 &&
              GetSelectedRelatedBlogs.find((x) => x.Id === item.Id) == undefined
            "
          />
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props:["search1"],
  name: "BlogRelatedContentComponent",

  mounted() { 
    this.blogs = this.GetBlogs.filter(
      (x) => x.Id != this.GetEditBlog.Id && x.Visibility
    ).map((x) => {
      if (
        this.GetSelectedRelatedBlogs.find((y) => y.Id === x.Id) != undefined
      ) {
        x.selected = true;
      } else {
        x.selected = false;
      }
      return x;
    });
    this.getBlogs = this.blogs
  },

  data() {
    return {
      getBlogs: [],
      switch1: true,
      selectedBlog: [],
      blogs: [],
      search: '',
      headers: [
        { text: "", value: "images" },
        { text: "", value: "title" },
        { text: "", value: "actions", sortable: false },
        {
          text: "",
          value: "",
          sort: function (a, b) {
            if (a ^ b) {
              return a && !b ? -1 : 1;
            } else {
              return 0;
            }
          },
        },
      ],
    };
  },
  methods: {
    onChange(obj, isChecked) {
      if (isChecked && this.GetSelectedRelatedBlogs.length < 3) {
        this.$store.dispatch("SetRelatedBlog", obj);
      } else if (!isChecked) {
        this.$store.dispatch("RemoveRelatedBlog", obj);
      } 
    },
    toggleIsPlaying(obj) {
      this.blogDataTableOne = this.blogDataTableOne.map((e) => {
        if (e.index === obj) {
          e.isPlaying = !e.isPlaying;
          return e;
        }
        return e;
      });
      this.isPlaying = !this.isPlaying;
    },
    fetchData() {
      var obj = {
        page: 1,
        pageSize: 10,
        search: this.search,
        filters: [],
      };
      this.tableLoader = true;
      this.$store.dispatch("GetBlogs", obj).then(() => {
        this.blogs = this.GetBlogs.filter(
          (x) => x.Id != this.GetEditBlog.Id && x.Visibility
        ).map((x) => {
          if (
            this.GetSelectedRelatedBlogs.find((y) => y.Id === x.Id) != undefined
          ) {
            x.selected = true;
          } else {
            x.selected = false;
          }
          return x;
        });
      });
    },
  },
  computed: {
    ...mapGetters(["GetBlogs", "GetSelectedRelatedBlogs", "GetEditBlog"]),
  },
};
</script>

<style scoped>
.chips_style {
  font-family: "DM Sans";
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: #009f06 !important;
  border-radius: 16px !important;
}

.date_time_style {
  font-family: "DM Sans";
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: rgba(8, 8, 22, 0.54);
}

h1 {
  font-family: "DM Sans";
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
  color: rgba(34, 34, 34, 1);
}
</style>
